import { SEARCH_SEARCH_AUDIO_BOOKS_SET_DATA } from 'rebook/apps/search/constants';


const initialState = {
  audioBookList: null,
  audioBooksCount: null,
  query: null,
  pageNumber: 1,
  lastPageNumber: 1,
  isLoading: true,
};

export default function searchAudioBooks(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SEARCH_AUDIO_BOOKS_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
